module.exports = __webpack_public_path__ + "static/img/banner2.4871d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selfPrinting/banner2.png
// module id = ZVHN
// module chunks = 10